import moment from 'moment';

export interface IServiceItem {
    deviceId: string;
    vehicleName: string;
    itemName: string;
    lastServiceDate: string;
    dueDate: string;
    daysLeft: number;
}

export interface IServiceGroups {
    expired: IServiceItem[];
    days30: IServiceItem[];
}

export const calculateServiceDueDate = (lastServiceDateStr: string, intervalMonths: number = 3) => {
    const today = moment().startOf('day');
    const lastService = moment(lastServiceDateStr, ['MM-DD-YYYY', 'YYYY-MM-DD']).startOf('day');

    if (!lastService.isValid()) return null;

    const dueDate = lastService.clone().add(intervalMonths, 'months');

    return {
        dueDateStr: dueDate.format('MM-DD-YYYY'),
        daysLeft: dueDate.diff(today, 'days')
    };
};

export const groupServiceNeeded = (items: IServiceItem[]): IServiceGroups => {
    const groups: IServiceGroups = {
        expired: [],
        days30: [],
    };

    items.forEach(item => {
        if (item.daysLeft < 0) {
            groups.expired.push(item);
        } else if (item.daysLeft >= 0 && item.daysLeft <= 30) {
            groups.days30.push(item);
        }
    });

    groups.expired.sort((a, b) => a.daysLeft - b.daysLeft);
    groups.days30.sort((a, b) => a.daysLeft - b.daysLeft);

    return groups;
};